module.exports = ["NABERS"]


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/static/hotel-rating-provider.json
// module id = 326
// module chunks = 0